import {api} from "@/lib/api/wallet/api";
import {IBalance} from "@/lib/types/wallet/IBalance";
import {IHasDeposits} from "@/lib/types/wallet/IHasDeposits";

export const profileApi = api.injectEndpoints({
    endpoints: build => ({
        getBalance: build.query<IBalance[], void>({
            query: () => ({
                url: '/api/v1/profile/balance',
                method: 'get',
            }),
            providesTags: ['Balance'],
        }),
        getHasDeposits: build.query<IHasDeposits, void>({
            query: () => ({
                url: '/api/v1/profile/has-deposits',
                method: 'get',
            })
        }),
    })
})

export const {useGetBalanceQuery, useGetHasDepositsQuery} = profileApi;
